import { Webcrypto } from '../../vendor/webcrypto/webcrypto'
import { store } from '../store'
import { ApiRequestService, ApiUrls } from './ApiRequestService'

class EncryptionServiceProvider {
  webcrypto: Webcrypto

  constructor() {
    this.webcrypto = new Webcrypto()
  }

  private static base64toBlob(base64Data: string, contentType: string): Blob {
    contentType = contentType || ''
    const sliceSize = 1024
    const byteCharacters = atob(base64Data)
    const bytesLength = byteCharacters.length
    const slicesCount = Math.ceil(bytesLength / sliceSize)
    const byteArrays = new Array(slicesCount)

    let sliceIndex = 0
    for (; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize
      const end = Math.min(begin + sliceSize, bytesLength)

      const bytes = new Array(end - begin)
      let offset = begin
      let i = 0
      for (; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0)
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes)
    }

    return new Blob(byteArrays, { type: contentType })
  }

  getClusterEncryptionKey(clusterID: number): string {
    if (!store.state.encryption_keys.items.hasOwnProperty(clusterID)) {
      return ''
    }
    return store.state.encryption_keys.items[clusterID]
  }

  async downloadEncryptedFile(fileID: number, clusterID: number, iv: string, filename: string, mimetype: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const reply = await ApiRequestService.get(ApiUrls.file.open + '/' + fileID)

        if (!reply || (reply.status !== 200) || !reply.data) {
          reject('EncryptionServiceProvider.downloadEncryptedFile() - error reading from API')
        }

        const data = reply.data
        const encryptionKey = this.getClusterEncryptionKey(clusterID)

        if (!encryptionKey) return reject()

        this.webcrypto.decrypt({
          data: data,
          key: encryptionKey,
          iv: iv,
          callback: (decrypted: any) => {
            if (decrypted.error) return reject()

            const blob = EncryptionServiceProvider.base64toBlob(decrypted.result, mimetype)

            if (window.navigator.msSaveOrOpenBlob) {
              return window.navigator.msSaveOrOpenBlob(blob, filename)
            }

            const a = document.createElement('a')
            document.body.appendChild(a)
            const url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = filename
            a.click()

            setTimeout(() => {
              window.URL.revokeObjectURL(url)
              document.body.removeChild(a)
            }, 0)

            resolve()
          }
        })
      } catch (e) {
        reject(e)
      }
    })
  }
}

export const EncryptionService = new EncryptionServiceProvider()
